/** @format */

import {toggleArrayValue} from 'helpers/arrayHelpers';
import {ChartIds} from 'pages/Home/DigitalCast/models/chartIds';
import {SaveSpace, Space, SpaceSelections} from 'pages/Home/DigitalCast/models/spaces';

interface Options extends SaveSpace {
  data: Space;
  widgetId: ChartIds;
}

const updateToggleChart = ({data, widgetId, saveSpaceSettings}: Options): Space => {
  const newSelections: SpaceSelections = {...data.chartSelected};
  newSelections.previous = [...newSelections.current];
  newSelections.current = toggleArrayValue(newSelections.current, widgetId);

  const result: Space = {
    ...data,
    chartSelected: newSelections,
  };

  saveSpaceSettings(result);

  return result;
};

export default updateToggleChart;
